"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var React = require("react");
var locales = require("date-fns/locale");
var DateInput_1 = require("@caddigital/sok-ui/lib/components/DateInput");
var constants_1 = require("utils/constants");
var react_redux_1 = require("react-redux");
var DatePicker = function (props) {
    var _a;
    var currentLanguage = (0, react_redux_1.useSelector)(function (state) { return state.translations; }).currentLanguage;
    return (React.createElement(DateInput_1.DateInput, __assign({ locale: (_a = locales[currentLanguage]) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_LANGUAGE }, props)));
};
exports.DatePicker = DatePicker;
